import React from 'react';

const Logo = ({token}) => (
  <div style={{height: "100px", maxWidth: "1200px", width: "100%", margin: "-24px auto 0 auto", paddingBottom: "60px"}} className="logoBlock">
    <a href="https://www.uvm.edu" title="Home" rel="home" className="header__logo imglink" id="logo" style={{
      paddingBottom: "1.7em",
      float: "left",
      height: "inherit",
      position: "absolute",
      marginLeft: "-5px",
    }}>
      <img className="logo-image" src={'https://www.uvm.edu/content/sites/all/themes/uvm_admin/images/uvmlogo-lite.svg?t=' + token}
        onMouseOver={e => ((e.currentTarget.src = 'https://www.uvm.edu/content/sites/all/themes/uvm_admin/images/uvmlogo-dark.svg?t=' + token))}
        onMouseOut={e => ((e.currentTarget.src = 'https://www.uvm.edu/content/sites/all/themes/uvm_admin/images/uvmlogo-lite.svg?t=' + token))}
        alt="University of Vermont"
        style={{
          width: window.innerWidth > 899 ? "400px" : "360px",
      }} />
    </a>
  </div>
);

export default Logo;
